(function () {
    "use strict";
    angular
        .module("skillBuilderSaaS")
        .directive("seminarLearnerAccessSelectSeminar", function () {
        return {
            restrict: "E",
            scope: {},
            bindToController: true,
            templateUrl: "app/account/learnerAccess/learningItemType/seminarLearnerAccessSelectSeminarView.html",
            controller: ["assignmentLearnerAccessSeminarResource", "$state", "$scope", "$uibModal", "messageService", "$translate", "frameworkService", "_", SeminarLearnerAccessSelectSeminarCtrl],
            controllerAs: "vm"
        };
        function SeminarLearnerAccessSelectSeminarCtrl(assignmentLearnerAccessSeminarResource, $state, $scope, $uibModal, messageService, $translate, frameworkService, _) {
            var vm = this;
            vm.number = $state.params.number;
            vm.version = $state.params.version;
            vm.code = $state.params.code;
            vm.languages = frameworkService.data.tenant.enabledLocalizations;
            vm.singleLanguageSite = frameworkService.data.tenant.enabledLocalizations.length === 1;
            vm.filters = {
                city: { value: "" },
                deliveryLanguage: { value: [] },
                facility: { value: "" }
            };
            vm.collapse = {};
            assignmentLearnerAccessSeminarResource.getSelectSeminarViewModel({ number: vm.number, version: vm.version, code: vm.code }, function (result) {
                vm.model = result;
                vm.model.seminarsGroupedByDate = _.groupBy(vm.model.seminars, function (seminar) {
                    var monthYear = $translate.instant("common.month." + new Date(seminar.startDate).getMonth()) + ", " + new Date(seminar.startDate).getFullYear();
                    vm.collapse[monthYear] = false;
                    return monthYear;
                });
                if (vm.model.seminars.length > 0) {
                    vm.collapse[Object.keys(vm.collapse)[0]] = true;
                }
                vm.loaded = true;
            }, function (error) {
                messageService.error(error);
            });
            ///////////////////////////////////////////////////////
            vm.customFilter = function (seminar) {
                if (seminar) {
                    if (vm.filters.deliveryLanguage.value.length > 0)
                        return _.includes(vm.filters.deliveryLanguage.value, seminar.deliveryLanguage);
                }
                return true;
            };
            vm.selectSeminar = function (id) {
                assignmentLearnerAccessSeminarResource.selectSeminar({ number: vm.number, version: vm.version, code: vm.code }, { seminarId: id }, function () {
                    messageService.success("learningItem.learnerAccess.seminar.enrollmentSuccess");
                    $state.go("main.learningPath.learningItemModal", { number: vm.number, version: vm.version, code: vm.code });
                }, function (error) {
                    messageService.error(error);
                });
            };
            vm.viewDetails = function (seminar) {
                var modalInstance = $uibModal.open({
                    templateUrl: "app/account/learnerAccess/learningItemType/seminarLearnerAccessViewSeminarDetailsView.html",
                    controller: "SeminarLearnerAccessViewSeminarDetailsCtrl as vm",
                    scope: $scope,
                    resolve: {
                        seminar: seminar
                    }
                });
                modalInstance.result.then(function (result) {
                    if (result)
                        vm.selectSeminar(result.id);
                }).catch(angular.noop);
            };
        }
    });
}());
